import { Button, Icon } from 'semantic-ui-react';

const ClothingActionButtons = ({
    fileInputRef,
    onFileInputClick,
    onLocalFileUpload,
    isOperationInProgress,
    preview,
    isEditMode = false
}) => {
    return (
        <div className="action-buttons">
            <input
                id="clothing-file-input"
                ref={fileInputRef}
                type="file"
                hidden
                onChange={onLocalFileUpload}
                accept="image/*,.heic"
            />

            <Button
                className="action-btn"
                color="teal"
                onClick={onFileInputClick}
                disabled={isOperationInProgress}
            >
                <Icon name="upload" />
                {preview ? 'Change Photo' : 'Upload Photo'}
            </Button>

            <Button
                className="action-btn"
                color="blue"
                onClick={onFileInputClick}
                disabled={isOperationInProgress}
            >
                <Icon name="camera" />
                Take Picture
            </Button>
        </div>
    );
};

export default ClothingActionButtons;
